import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import RecordingView from './RecordingView';
import IdleView from './IdleView';
import NoteView from './NoteView';
import InactivityDialog from './InactivityDialog';
import useScribeSession from './useScribeSession';

export default function ScribeSessionPanel({
  siteId, mkey, intakeReport, verbosity, noteTemplate,
}) {
  const {
    isRecording,
    note,
    isGeneratingNote,
    hasExistingTranscript,
    showInactivityDialog,
    analyzerNode,
    start,
    stop,
    generateNote,
    dismissDialog,
  } = useScribeSession(siteId, mkey, intakeReport, verbosity, noteTemplate);

  const renderContent = () => {
    if (isRecording) {
      return <RecordingView analyzerNode={analyzerNode} onStop={stop} />;
    }
    if (note) {
      return (
        <NoteView
          note={note}
          isGeneratingNote={isGeneratingNote}
          onRegenerate={generateNote}
          onContinue={start}
        />
      );
    }
    return (
      <IdleView
        hasExistingTranscript={hasExistingTranscript}
        isGeneratingNote={isGeneratingNote}
        onStart={start}
        onGenerate={generateNote}
      />
    );
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        bgcolor: 'background.paper',
      }}
    >
      {renderContent()}
      <InactivityDialog open={showInactivityDialog} onClose={dismissDialog} />
    </Paper>
  );
}

ScribeSessionPanel.propTypes = {
  siteId: PropTypes.string.isRequired,
  mkey: PropTypes.string.isRequired,
  intakeReport: PropTypes.string.isRequired,
  verbosity: PropTypes.string,
  noteTemplate: PropTypes.string,
};

ScribeSessionPanel.defaultProps = {
  verbosity: 'moderate',
  noteTemplate: '',
};
